import { inject, Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { ContactDetails } from 'src/app/models/contact.model';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  private readonly apiService = inject(ApiService);

  getContactDetails(icnNo: number) {
    return this.apiService.get<ContactDetails[]>(
      `contactDetail`,
      `?icnNo=${icnNo}`,
    );
  }
}
